import React, { lazy } from 'react';
import { type Route, type Routes } from 'react-resource-router';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const InferredProjectsPage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-inferred-projects" */ '../../pages/inferred-projects'
		),
);

const InferredProjectsPageWithAccess: React.FC = () => (
	<AppAccessGate appName="Labs">
		<InferredProjectsPage />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/inferred-projects' as const;

const inferredProjectsRoutesObject: Record<string, Route> = {
	home: {
		name: 'inferred-projects',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(InferredProjectsPageWithAccess),
	},
};

export const inferredProjectsRoutes: Routes = Object.values(inferredProjectsRoutesObject);
